import { createContext, useEffect, useState } from "react";
import Typo from "typo-js";

export const DictionaryContext = createContext({});

export const DictionaryProvider = ({ children }) => {
    const [dictionary, setDictionary] = useState(null);

    useEffect(() => {
        Promise.all([
            fetch("/dictionaries/en_US/en_US.aff").then((res) => res.text()),
            fetch("/dictionaries/en_US/en_US.dic").then((res) => res.text()),
        ]).then(([affData, dicData]) => {
            setDictionary(new Typo("en_US", affData, dicData));
        });
    }, []);

    return <DictionaryContext.Provider value={{ dictionary }}>{children}</DictionaryContext.Provider>;
};
